import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ChainsEndpoints as Endpoints,
  type GetChainRequest,
  type GetChainResponse,
  type GetChainsForSystemRequest,
  type GetChainsForSystemResponse,
  type GetChainsRequest,
  type GetChainsResponse,
  type UpdateChainRequest,
  type UpdateChainResponse,
} from '@app/api/Chains/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { CHAINS_CHUNK } from '@app/constants';

export const chainsApi = createApi({
  reducerPath: 'chainsApi2',
  baseQuery: createApiBaseQuery(CHAINS_CHUNK),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.UpdateChain]: mutation<UpdateChainResponse, UpdateChainRequest>({
      query: ({ data, ...params }) => ({
        url: Endpoints.UpdateChain,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetChains]: query<GetChainsResponse, GetChainsRequest>({
      query: (params) => ({
        url: Endpoints.GetChains,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetChainsForSystem]: query<
      GetChainsForSystemResponse,
      GetChainsForSystemRequest
    >({
      query: (params) => ({
        url: Endpoints.GetChainsForSystem,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetChain]: query<GetChainResponse, GetChainRequest>({
      query: (params) => ({
        url: Endpoints.GetChain,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useUpdateChainMutation,
  useGetChainsQuery,
  useLazyGetChainsQuery,
  useGetChainsForSystemQuery,
  useLazyGetChainsForSystemQuery,
  useGetChainQuery,
  useLazyGetChainQuery,
} = chainsApi;
